import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Save } from 'lucide-react'
import { categoriesSchema } from '../types'
import type { CategoriesFormData } from '../types'

interface CategoriesFormProps {
  defaultValues: CategoriesFormData
  onSubmit: (data: CategoriesFormData) => void
  isSubmitting: boolean
}

export function CategoriesForm({
  defaultValues,
  onSubmit,
  isSubmitting,
}: CategoriesFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CategoriesFormData>({
    resolver: zodResolver(categoriesSchema),
    defaultValues,
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Oro</label>
        <input
          {...register('oro', { valueAsNumber: true })}
          type="number"
          className="input"
        />
        {errors.oro && (
          <p className="text-red-500 text-sm mt-1">{errors.oro.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Mármol</label>
        <input
          {...register('marmol', { valueAsNumber: true })}
          type="number"
          className="input"
        />
        {errors.marmol && (
          <p className="text-red-500 text-sm mt-1">{errors.marmol.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Bronce</label>
        <input
          {...register('bronce', { valueAsNumber: true })}
          type="number"
          className="input"
        />
        {errors.bronce && (
          <p className="text-red-500 text-sm mt-1">{errors.bronce.message}</p>
        )}
      </div>

      <button type="submit" disabled={isSubmitting} className="btn btn-primary flex items-center gap-1.5">
        <Save size={16} />
        {isSubmitting ? 'Guardando...' : 'Guardar'}
      </button>
    </form>
  )
}
